import { get } from '@/axios'

export interface IHistoryGetByResourceRequest {
  resource_id: string
  resource_type: number
}

export interface IHistoryGetByResourceResponse {
  history_data: IHistoryData
  is_history: boolean
}

export interface IHistoryData {
  chapter_id: string
  progress: number
  resource_id: string
  resource_type: number
}

export const historyGetByResource = async (params: IHistoryGetByResourceRequest) => {
  const response = await get<IHistoryGetByResourceResponse>(`/history/getByResource`, params, { 'Cache-Control': 'no-cache' })

  return response
}
